import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { LandingPage } from "../pages/Landing";
import { NotFoundPage } from "../pages/NotFound";
import { ContactSuccess } from "../pages/ContactSuccess";
import { useEffect } from "react";
import { logPageView } from "../services/firebase/analytics";
import { Layout } from "../components/Layout";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      {/* Italian routes (default) */}
      <Route index element={<LandingPage />} />
      <Route path="contact/success" element={<ContactSuccess />} />
      
      {/* English routes */}
      <Route path="en" element={<LandingPage />} />
      <Route path="en/contact/success" element={<ContactSuccess />} />
      
      {/* 404 route */}
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  )
);

export const Navigation = () => {
  useEffect(() => {
    const unsubscribe = router.subscribe(({ location }) => {
      logPageView(location.pathname);
    });
    return () => unsubscribe();
  }, [router]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};
